var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSiemens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.919,
    height: 8.897,
    viewBox: "0 0 55.919 8.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Siemens-logo.svg",
    transform: "translate(28.089 -0.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(-29.999 -2.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M57.175,2.956V4.621a6.636,6.636,0,0,0-2.3-.49,1.845,1.845,0,0,0-.954.216.624.624,0,0,0-.36.53c0,.278.269.525.811.746l1.566.762c1.266.6,1.894,1.4,1.894,2.411a2.352,2.352,0,0,1-1.005,2,4.387,4.387,0,0,1-2.684.746,12.467,12.467,0,0,1-1.391-.069,10.755,10.755,0,0,1-1.41-.265V9.464a8.28,8.28,0,0,0,2.628.49c.941,0,1.41-.273,1.41-.823,0-.274-.192-.5-.581-.669l-1.739-.741a3.579,3.579,0,0,1-1.431-1.058,2.393,2.393,0,0,1-.463-1.453,2.209,2.209,0,0,1,.966-1.863,4.29,4.29,0,0,1,2.571-.7,9.558,9.558,0,0,1,1.189.087C56.333,2.791,56.762,2.865,57.175,2.956Z",
    fill: "#099",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M7.92,2.956V4.621a6.631,6.631,0,0,0-2.3-.49,1.842,1.842,0,0,0-.954.216.624.624,0,0,0-.36.53c0,.278.273.525.815.746l1.566.762c1.261.6,1.89,1.4,1.89,2.411a2.361,2.361,0,0,1-1,2,4.4,4.4,0,0,1-2.688.746,12.493,12.493,0,0,1-1.393-.069,10.856,10.856,0,0,1-1.408-.265V9.464a8.316,8.316,0,0,0,2.626.49c.941,0,1.41-.273,1.41-.823,0-.274-.191-.5-.577-.669L3.806,7.721A3.511,3.511,0,0,1,2.375,6.663,2.363,2.363,0,0,1,1.91,5.21a2.2,2.2,0,0,1,.967-1.863,4.268,4.268,0,0,1,2.568-.7,9.63,9.63,0,0,1,1.192.087C7.08,2.791,7.509,2.865,7.92,2.956Z",
    fill: "#099",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 2.55,
    height: 8.585,
    transform: "translate(9.715 2.8)",
    fill: "#099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M20.481,2.8V4.387H16.692v1.9h3.286V7.721H16.692v2h3.867v1.665H14.238V2.8Z",
    fill: "#099",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M32.387,2.8v8.585H30.006V5.723l-2.47,5.741h-1.47L23.69,5.723v5.662H21.968V2.8h3.113l2.125,5.255L29.43,2.8Z",
    fill: "#099",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M40.6,2.8V4.387H36.831v1.9h3.286V7.721H36.831v2h3.846v1.665H34.356V2.8Z",
    fill: "#099",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M49.548,2.8v8.585H46.843L43.807,5.879v5.506H42.086V2.8H44.87l2.957,5.412V2.8Z",
    fill: "#099",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSiemens);
export default __webpack_public_path__ + "static/media/logo-siemens.b8c5ef07fbd062c4faf58f671fe6ee53.svg";
export { ForwardRef as ReactComponent };